<div class="container-fluid">
  <app-custom-table-title [icon]="icon" [title]="title" [subTitle]="subTitle"></app-custom-table-title>

  <div class="mt-4 px-4 cf-table-card">
    <app-custom-table #table="customTable" [config]="tableConfig"></app-custom-table>
  </div>
</div>